import { Base } from '@studiometa/js-toolkit';

/**
 * Menu component
 */
export default class Menu extends Base {
  static config = {
    name: 'Menu',
    refs: ['menuBtn', 'menu', 'menuBg'],
  };

  /**
   * Toggle menu visibility
   */
  onMenuBtnClick() {
    this.$refs.menu.classList.toggle('max-l:hidden');
    this.$refs.menuBtn.classList.toggle('is-open');
  }

  /**
   *
   */
  scrolled(props) {
    if (props.y > 0) {
      this.$refs.menuBg.classList.add('is-scrolled');
      this.$refs.menu.classList.add('is-scrolled');
    } else {
      this.$refs.menuBg.classList.remove('is-scrolled');
      this.$refs.menu.classList.remove('is-scrolled');
    }
  }
}
